const rebuyTrigger = document.querySelector('.js-rebuy-smartcart-trigger');

if (rebuyTrigger) {
  rebuyTrigger.addEventListener("click", function(e) {
    e.preventDefault();
  });

  document.addEventListener('rebuy:smartcart.ready', function() {
    if (rebuyTrigger) {
      rebuyTrigger.addEventListener('click', function() {
        Rebuy.SmartCart.show();
      });
    }
  });
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    const details = event.currentTarget.closest('details');
    
    // Handle regular details elements normally
    if (!details.classList.contains('js-accordion-block')) {
      event.currentTarget.setAttribute('aria-expanded', !details.hasAttribute('open'));
      return;
    }

    // Handle accordion blocks with animation
    event.preventDefault();
    const content = details.querySelector('summary + *');
    const dataId = details.getAttribute('data-id');
    const isOpen = details.hasAttribute('open');
    
    // Set up animation properties
    content.style.overflow = 'hidden';
    content.style.transition = 'height 0.2s ease, opacity 0.2s ease';
    
    if (!isOpen) {
      // Opening animation
      details.setAttribute('open', '');
      content.style.height = '0';
      content.style.opacity = '0';
      // Get natural height
      const height = content.scrollHeight;
      // Trigger animation
      requestAnimationFrame(() => {
        content.style.height = height + 'px';
        content.style.opacity = '1';
      });
      
      // Close other accordions with same data-id
      if (dataId) {
        document.querySelectorAll(`details[data-id="${dataId}"]`).forEach(otherDetails => {
          if (otherDetails !== details && otherDetails.hasAttribute('open')) {
            const otherContent = otherDetails.querySelector('summary + *');
            otherContent.style.height = '0';
            otherContent.style.opacity = '0';
            // Remove open after animation
            setTimeout(() => {
              otherDetails.removeAttribute('open');
              otherDetails.querySelector('summary').setAttribute('aria-expanded', 'false');
            }, 300);
          }
        });
      }
    } else {
      // Closing animation
      content.style.height = content.scrollHeight + 'px';
      requestAnimationFrame(() => {
        content.style.height = '0';
        content.style.opacity = '0';
      });
      // Remove open after animation
      setTimeout(() => {
        details.removeAttribute('open');
      }, 300);
    }

    event.currentTarget.setAttribute('aria-expanded', !isOpen);
    
    // Clean up after animation
    content.addEventListener('transitionend', () => {
      if (details.hasAttribute('open')) {
        content.style.height = 'auto';
      }
    }, {once: true});
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container=document, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if ( event.target.name === 'plus') {
        this.buttonMinusEl.removeAttribute('disabled');
    }else{
      //minus
      if( this.input.value <=1){
        this.buttonMinusEl.setAttribute('disabled', 'disabled');
      }
    }

    if (document.querySelector('.rc-container-wrapper') === null) {
      document.querySelector('.price-item--regular').classList.remove("hidden");
    }
  }

  connectedCallback() {
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.buttonPlusEl = this.querySelector('button[name="plus"]');
    this.buttonMinusEl = this.querySelector('button[name="minus"]');

    if( this.input.value <=1){
        this.buttonMinusEl.setAttribute('disabled', 'disabled');
    }

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );

  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button:not(.disclosure__button)').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement.classList.contains('mobile-facets__disclosure')) {
      const headerSection = document.querySelector('#shopify-section-header');
      headerSection.classList.remove('mobile-facets-open');

      if (!detailsElement.classList.contains('menu-opening')) {
        headerSection.classList.add('mobile-facets-open');
      }
    }

    if (summaryElement.classList.contains('header-drawer__link')) {
      this.animationDuration = 400;

      function addTrapFocus() {
        trapFocus(summaryElement.nextElementSibling);
        summaryElement.nextElementSibling.removeEventListener(
          'transitionend',
          addTrapFocus
        );
      }

      if (isOpen) event.preventDefault();

      if (detailsElement === this.mainDetailsToggle) {
        isOpen
          ? this.closeMenuDrawer(event, summaryElement)
          : this.openMenuDrawer(summaryElement);
      } else {
        setTimeout(() => {
          let parentScrollContainer = detailsElement.parentNode;
          while (
            !parentScrollContainer.hasAttribute('data-scroll-container')
          ) {
            parentScrollContainer = parentScrollContainer.parentNode;
          }
          parentScrollContainer.classList[isOpen ? 'remove' : 'add'](
            'has-open-submenu'
          );
          if (this.previousLockedContainer == null) {
            this.previousLockedContainer = this.currentLockedContainer;
          }
          this.currentLockedContainer =
            summaryElement.nextElementSibling;
          parentScrollContainer.scroll({
            top: 0,
            behavior: 'smooth'
          });
          detailsElement.classList[isOpen ? 'remove' : 'add'](
            'menu-opening'
          );
          summaryElement.setAttribute('aria-expanded', !isOpen);
          isOpen && this.closeAnimation(detailsElement);
        }, 50);
      }
    } else {
      const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

      function addTrapFocus() {
        trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
        summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
      }

      if (detailsElement === this.mainDetailsToggle) {
        if(isOpen) event.preventDefault();
        isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
      } else {
        setTimeout(() => {
          detailsElement.classList.add('menu-opening');
          summaryElement.setAttribute('aria-expanded', true);
          !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
        }, 100);
      }
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    var element = document.getElementById("chevron-expand-menu");
    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {

      //details.removeAttribute('open');
      if (element) {
        element.classList.remove("mirror-horizontaly");
      };

      details.classList.remove('menu-opening');
    });

    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      // tu była zmiana
      // if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);


class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
    this.closeButton = this.querySelector('[data-close]');
    this.oldY = 0;

    this.closeButton.addEventListener('click', (event) => {
      this.closeMenuDrawer();
    });

    this.scrollContainer = this.querySelector(
      '[data-scroll-container]'
    );
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header ||
      document.querySelector(
        '.header-wrapper header, sticky-header'
      );

    updateHeaderPosition();
    this.header.classList.add('menu-open');

    this.oldY = window.scrollY;
    window.scrollTo(0, 0);
    document.body.style.position = 'fixed';
    document.body.style.top = `-${this.oldY}px`;
    document.body.style.width = '100%';

    super.openMenuDrawer(summaryElement);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');

    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, this.oldY);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.navigation = this.querySelector('.slideshow__controls');
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
    if (this.sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage.toString().padStart(2, '0');
      this.pageTotalElement.textContent = this.totalPages.toString().padStart(2, '0');
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    const currentSlide = Array.from(this.sliderItems).filter(sliderItem => sliderItem.getAttribute('aria-hidden') === 'false')[0];

    this.navigation?.classList.toggle('slideshow__controls--light', currentSlide?.dataset.color === 'light');

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderLastItem)) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderLastItem.clientWidth) : this.slider.scrollLeft - (step * this.sliderLastItem.clientWidth);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton;
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.priceElID = `price-${this.dataset.pid}`;
  }

  clickMediaImage() {
    if(!this.currentVariant) return;
    const target = this.closest('section').querySelector(`[js-media-id="${this.currentVariant.id}"]`);
    if(!target) return;
    target.click();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateSellingPlanAttribute();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData(this.modal).find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    this.clickMediaImage();
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    if ( -1 !== window.location.href.indexOf('/products/') ){
       window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}`) //${this.dataset.section}
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destinations = document.querySelectorAll('.price__wrapper');
        const source = html.getElementById(this.priceElID);

        const retailPrice = html.getElementById('retail-price');
        const retailPriceWrapper = document.querySelector('#retail-price');

        if (retailPrice && retailPriceWrapper) {
          retailPriceWrapper.innerHTML = retailPrice.innerHTML;
        }

        let isSoldout = false;
        if (this.currentVariant.available === false || html.querySelector('.js-available-badge').dataset.soldout === 'true') {
          isSoldout = true;
        };

        if (source && destinations.length) {
          destinations.forEach(destination => {
            destination.innerHTML = source.innerHTML;
          });
        }

        const prices = document.querySelectorAll('.price__wrapper');
        prices.forEach(price => {
          price.classList.remove('visibility-hidden');
        });
        
        this.toggleAddButton(isSoldout, window.variantStrings.soldOut);
        this.updateSellingPlanAttribute();
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    let productForm = document.getElementById(`product-form-${this.dataset.section}`);

    if (this.closest('.quickshop')) {
      const quickshopModal = this.closest('.quickshop');
      productForm = quickshopModal;
    }

    if (!productForm) return;

    let addButton = productForm.querySelector('[name="add"]');

    if (this.closest('.quickshop')) {
      addButton = productForm.querySelector('.product-form__buttons button');
    }

    if (!addButton) return;

    const addButtonText = addButton.querySelector('.js-text');
    const addButtonIcon = addButton.querySelector('.js-icon');

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
      addButtonIcon.classList.add('hidden')
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
      addButton.setAttribute('data-disabled', false);
      addButtonIcon.classList.remove('hidden');
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(this.priceElID);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData(modal) {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updateSellingPlanAttribute() {
    // Find the context (quickshop modal or main product page)
    const isQuickshop = this.closest('.quickshop');
    const context = isQuickshop || this.closest('section') || this.closest('product-form');
    
    if (!context) return;

    // Find the submit button
    let submitButton = null;
    
    if (isQuickshop) {
      // For quickshop: find button in .product-form__buttons
      const productFormButtons = context.querySelector('.product-form__buttons');
      if (productFormButtons) {
        submitButton = productFormButtons.querySelector('button');
      }
    } else {
      // For main product page: find button with name="add" or .product-form__submit
      const productForm = context.querySelector('form') || context;
      submitButton = productForm.querySelector('[name="add"]') || productForm.querySelector('.product-form__submit');
    }

    if (!submitButton) return;

    // Find subscription-options component
    // For quickshop: find the one for current variant (not hidden)
    // For main product page: find any subscription-options
    let subscriptionOptions = null;
    
    if (isQuickshop && this.currentVariant) {
      // Find subscription widget for current variant (not hidden)
      const variantWidget = context.querySelector(`.subscription-widget__variant-${this.currentVariant.id}:not(.hidden)`);
      if (variantWidget) {
        subscriptionOptions = variantWidget.querySelector('subscription-options');
      }
    } else {
      // For main product page, find any subscription-options
      subscriptionOptions = context.querySelector('subscription-options');
    }
    
    if (!subscriptionOptions) {
      // If no subscription-options component exists, remove the attribute
      submitButton.removeAttribute('data-selling-plan-id');
      return;
    }

    // Get the selected purchase type
    const selectedRadio = subscriptionOptions.querySelector('.subscription-widget__radio:checked');
    
    if (!selectedRadio) {
      submitButton.removeAttribute('data-selling-plan-id');
      return;
    }

    const purchaseType = selectedRadio.value;

    if (purchaseType === 'onetime') {
      // Remove selling plan attribute for one-time purchase
      submitButton.removeAttribute('data-selling-plan-id');
    } else if (purchaseType === 'subscription') {
      // Get the selected selling plan from the select
      const selectElement = subscriptionOptions.querySelector('.subscription-widget__select');
      
      if (selectElement && selectElement.value && selectElement.value !== '') {
        // Add selling plan id as data attribute
        submitButton.setAttribute('data-selling-plan-id', selectElement.value);
      } else {
        // Remove attribute if no plan selected
        submitButton.removeAttribute('data-selling-plan-id');
      }
    }
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));

    this.options = fieldsets.map((fieldset) => {
      if(fieldset.classList.contains('inside-modal')) this.modal = true
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

// Recharge Custom JS
window.rechargeCustomTheme = {
    selectors: {
        price: ['.price-item--sale']
    }
}

// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
var Shopify = Shopify || {};
Shopify.numberFormat = new Intl.NumberFormat(
  `${Shopify.locale}-${Shopify.country}`,
  {
    style: 'currency',
    currency: Shopify.currency.active,
  }
);
Shopify.formatCurrency = (price) => Shopify.numberFormat.format(price);

// Update header position on resize
function updateHeaderPosition() {
  const header = document.querySelector('.header-wrapper header, sticky-header');

  if (header) {
    setTimeout(() => {
      if(!header.classList.contains('menu-open')){
        document.documentElement.style.setProperty(
          '--header-top-position',
          `${header.getBoundingClientRect().bottom}px`
        );
      }
    }, 100);
  }
}

// Add resize listener
window.addEventListener('resize', debounce(updateHeaderPosition, 150));

// Add scroll listener
window.addEventListener('scroll', updateHeaderPosition);

// Initial position set
document.addEventListener('DOMContentLoaded', updateHeaderPosition);

// Update header height CSS variable
function updateHeaderHeightVariable() {
  const announcementBar = document.querySelector('.announcement-bar');
  const sectionHeader = document.querySelector('.section-header');
  
  let totalHeight = 0;
  
  if (announcementBar) {
    totalHeight += announcementBar.offsetHeight;
  }
  
  if (sectionHeader) {
    totalHeight += sectionHeader.offsetHeight;
  }
  
  document.documentElement.style.setProperty('--headerHeight', `${totalHeight}px`);
}

// Add event listeners for header height updates
window.addEventListener('load', updateHeaderHeightVariable);
window.addEventListener('resize', debounce(updateHeaderHeightVariable, 150));

// Initial header height set
document.addEventListener('DOMContentLoaded', updateHeaderHeightVariable);
